import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-windows-mobile-dev',
  templateUrl: './windows-mobile-dev.component.html',
  styleUrls: ['./windows-mobile-dev.component.css']
})
export class WindowsMobileDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/windows-mobile-dev/windows-mobile-dev.component.ts